import { LucideIcon } from 'lucide-react';
import { Card } from './ui/Card';

interface KpiCardProps {
  title: string;
  amount: number;
  icon: LucideIcon;
  insight?: string;
  status?: 'success' | 'warning' | 'danger' | 'neutral';
}

export function KpiCard({ title, amount, icon: Icon, insight, status = 'neutral' }: KpiCardProps) {
  const statusColors = {
    success: {
      iconBg: 'bg-green-50 text-green-600',
      text: 'text-green-600'
    },
    warning: {
      iconBg: 'bg-orange-50 text-orange-600',
      text: 'text-orange-600'
    },
    danger: {
      iconBg: 'bg-red-50 text-red-600',
      text: 'text-red-600'
    },
    neutral: {
      iconBg: 'bg-blue-50 text-blue-600',
      text: 'text-blue-600'
    }
  };

  const colors = statusColors[status];

  return (
    <Card className="h-full flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <p className="text-sm font-medium text-gray-600">{title}</p>
        <div className={`p-2.5 rounded-lg ${colors.iconBg}`}>
          <Icon size={20} />
        </div>
      </div>
      <p className={`text-3xl font-bold ${colors.text}`}>
        {amount >= 0 && amount !== 0 ? '+' : ''}{amount.toFixed(2)} €
      </p>
      {insight && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <p className="text-sm text-gray-600 leading-relaxed">{insight}</p>
        </div>
      )}
    </Card>
  );
}
